/**
 * File teamCollapse.js
 *
 * Handles triggering of collapsing the team bios.
 */

(function ($) {
    $('.toggle-bio-card').on('click', function (e) {
        $('.toggle-bio-card.active').map(function () {
            $(this).removeClass('active');
            removeActive($(this));
        });
        cardArrow($(this));
        e.preventDefault();

        let card = $(this).closest('.modop-bio-card');
        let row = card.closest('.row');
        let existingNewRow = row.find('.bios');

        if (card.hasClass('active')) {
            card.removeClass('active').closest('.column').removeClass('col-6').addClass('col-sm-3');
            existingNewRow.remove();
        } else {
            $('.modop-bio-card').removeClass('active');
            $('.bios').remove();
            card.addClass('active').closest('.column').removeClass('col-sm-3').addClass('col-6');
            let col6 = row.find('.col-6');

            if ($(window).width() < 768) {
                let newRow = $('<div class="row bios"></div>');

                if (col6.length % 2 === 0) {
                    if ($(this).parent().parent().parent().index() === 0) {
                        col6.eq(1).after(newRow);
                    } else if ($(this).parent().parent().parent().index() === 2) {
                        col6.eq(3).after(newRow);
                    } else {
                        $(this).parent().parent().parent().after(newRow);
                    }
                    newRow.append(card.find('.modop-bio-card-inner').clone());
                    newRow.find('.modop-bio-card-inner').fadeToggle();
                    $(newRow).prev().find('h4.team-card-title').toggle();
                    $(newRow).prev().find('h5.team-card-intro').toggle();
                    $(newRow).prev().prev().find('h4.team-card-title').toggle();
                    $(newRow).prev().prev().find('h5.team-card-intro').toggle();
                } else {
                    if ($(this).parent().parent().parent().index() === 0) {
                        col6.eq(1).after(newRow);
                        console.log(0);
                        $(newRow).prev().find('h4.team-card-title').toggle();
                        $(newRow).prev().find('h5.team-card-intro').toggle();
                        $(newRow).prev().prev().find('h4.team-card-title').toggle();
                        $(newRow).prev().prev().find('h5.team-card-intro').toggle();
                    } else if ($(this).parent().parent().parent().index() === 2) {
                        $(this).parent().parent().parent().parent().after(newRow);
                        console.log(2);
                        $(newRow).prev().find('.active').find('h4.team-card-title').toggle();
                        $(newRow).prev().find('.active').find('h5.team-card-intro').toggle();
                    } else {
                        $(this).parent().parent().parent().after(newRow);
                        console.log('other');
                        $(newRow).prev().find('h4.team-card-title').toggle();
                        $(newRow).prev().find('h5.team-card-intro').toggle();
                        $(newRow).prev().prev().find('h4.team-card-title').toggle();
                        $(newRow).prev().prev().find('h5.team-card-intro').toggle();
                    }
                    newRow.append(card.find('.modop-bio-card-inner').clone());
                    newRow.find('.modop-bio-card-inner').fadeToggle();
                }
            } else {
                let newRow = $('<div class="row bios"></div>');
                $(this).parent().parent().parent().parent().after(newRow);
                newRow.append(card.find('.modop-bio-card-inner').clone());
                newRow.find('.modop-bio-card-inner').fadeToggle();
                console.log($(this).parent().parent().parent().parent());
                $(this).parent().parent().parent().parent().find('h4.team-card-title').toggle();
                $(this).parent().parent().parent().parent().find('h5.team-card-intro').toggle();
            }
            closeCard();
        }
    });
    function closeCard() {
        $('.close').on('click', function () {
            $('.modop-bio-card').removeClass('active');
            $('.toggle-bio-card').removeClass('active');
            $(this).closest('.bios').remove();
            $('.modop-bio-card').find('.down-arrow').hide();
            $('.modop-bio-card').find('.member-thumbnail').css('filter', 'grayscale(100%)');
            $('h4.team-card-title, h5.team-card-intro').show();
        });
    }
    function cardArrow(toggleBio) {
        if (!$(toggleBio).parent().parent().hasClass('active')) {
            toggleBio.find('.down-arrow').show();
            toggleBio.find('.member-thumbnail').css('filter', 'grayscale(0)');
            toggleBio.addClass('active');
        } else {
            removeActive(toggleBio);
        }
    }

    function removeActive(activeEl) {
        $('.toggle-bio-card .down-arrow').hide();
        activeEl.find('.member-thumbnail').css('filter', 'grayscale(100%)');
        activeEl.removeClass('active');
        $('.bios').remove();
        $('h4.team-card-title, h5.team-card-intro').show();
    }
})(jQuery);
